import React from 'react';
import { Card, Divider, Text } from '@wegroup/design-system';
import { InsurancePolicyClause } from '../../../../../../../types/AdvisoryReport';

interface Props {
  data: InsurancePolicyClause;
  indexNumber: number;
}

const InsurancePolicyClauseItem: React.FC<Props> = ({ data, indexNumber }) => {
  return (
    <Card boxShadow="none" p="0">
      <Text textStyle="normalBodyMedium" color="gray.700" p="3">
        {indexNumber}. {data.title}
      </Text>
      {data.description && (
        <>
          <Divider borderColor="gray.50" />
          <Text p="3" textStyle="smallBody">
            {data.description}
          </Text>
        </>
      )}
    </Card>
  );
};

export default InsurancePolicyClauseItem;
